var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimestampImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.25C7.91421 6.25 8.25 6.58579 8.25 7V9.25H10.5C10.9142 9.25 11.25 9.58579 11.25 10C11.25 10.4142 10.9142 10.75 10.5 10.75H6.75V7C6.75 6.58579 7.08579 6.25 7.5 6.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 4C10.1123 4 12.3334 5.66984 13.1572 8H19.5C21.1569 8 22.5 9.34315 22.5 11V17C22.5 18.6569 21.1569 20 19.5 20H7.5C5.84315 20 4.5 18.6569 4.5 17V15.1953C2.70707 14.1578 1.5 12.2205 1.5 10C1.5 6.68629 4.18629 4 7.5 4ZM11.0117 17.6113L9.57129 15.6318C9.55313 15.6385 9.53484 15.6449 9.5166 15.6514L6.53223 17.248C6.64266 17.6802 7.03344 18 7.5 18H19.5C19.9379 18 20.309 17.7181 20.4443 17.3262L17.6367 14.2363L11.0117 17.6113ZM13.5 10C13.5 11.8643 12.6493 13.5294 11.3154 14.6299L11.625 15.0547L18.0898 11.7627L20.5 14.4131V11C20.5 10.4477 20.0523 10 19.5 10H13.5ZM7.5 5.5C5.01472 5.5 3 7.51472 3 10C3 12.4853 5.01472 14.5 7.5 14.5C9.98528 14.5 12 12.4853 12 10C12 7.51472 9.98528 5.5 7.5 5.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimestampImage);
export default __webpack_public_path__ + "static/media/Timestamp_image.3da71619f302581b66555240eea463dc.svg";
export { ForwardRef as ReactComponent };